module.exports = __webpack_public_path__ + "img/311.199d8e14.jpg";